window.storeTime = "08";
window.storeNow = "2026-10-22T08:18:01";
window.storeHour = 08;
window.cartItems = null;
window.cartProductIds = [];
const STORE_LOCALE = null;

const CUT_OFF_HOUR = 22;
const ENABLE_TEST_DAYS = true; // <-- Set to false after testing
const ENABLE_LOGS = true;
const ACTIVE_LANGUAGE = String(STORE_LOCALE || "nl").toLowerCase().split("-")[0] === "fr"
  ? "fr"
  : "nl";
const MESSAGES = {
  nl: {
    deliveryDateUpdated: "Bezorgdatum bijgewerkt",
    unavailableDate: "De door u gekozen bezorgdatum {date} is niet meer beschikbaar.",
    nextAvailableDate: "We hebben automatisch de eerstvolgende beschikbare bezorgdatum geselecteerd:",
    ok: "OK",
    mixedCartTitle: "Apart bestellen",
    preorderAvailableFrom: "Pre-orderproducten zijn beschikbaar vanaf<br><b>{date}</b>.",
    preorderAddedLast: "Verwijder het laatst toegevoegde pre-orderproduct om uw overige producten te behouden.",
    preorderAddedFirst: "Behoud het eerst toegevoegde pre-orderproduct en verwijder de overige producten.",
    removePreorder: "Pre-orderproducten verwijderen",
    keepPreorder: "Pre-order behouden en overige producten verwijderen",
    continue: "Verdergaan",
    removing: "Verwijderen...",
    cartUpdateFailed: "We konden uw winkelwagen niet bijwerken. Probeer het opnieuw."
  },
  fr: {
    deliveryDateUpdated: "Date de livraison mise à jour",
    unavailableDate: "La date de livraison choisie, le {date}, n’est plus disponible.",
    nextAvailableDate: "La prochaine date de livraison disponible a été sélectionnée automatiquement :",
    ok: "OK",
    mixedCartTitle: "À commander séparément",
    preorderAvailableFrom: "Les produits en précommande sont disponibles à partir du {date}.",
    preorderAddedLast: "Supprimez le dernier produit en précommande ajouté pour conserver les autres produits.",
    preorderAddedFirst: "Le produit en précommande a été ajouté en premier. Conservez-le et supprimez les autres produits de votre panier.",
    removePreorder: "Supprimer les produits en précommande",
    keepPreorder: "Conserver la précommande et supprimer les autres produits",
    continue: "Continuer",
    removing: "Suppression...",
    cartUpdateFailed: "Impossible de mettre à jour votre panier. Veuillez réessayer."
  }
};
const DATE_LOCALE = ACTIVE_LANGUAGE === "fr" ? "fr-FR" : "nl-NL";
const DECEMBER_PRODUCT_IDS = [
  "15781564416340",
  "15781571428692",
  "15781533385044"
];
const DECEMBER_PRODUCT_ID_SET = new Set(DECEMBER_PRODUCT_IDS.map(String));
const DECEMBER_MINIMUM_DATE = new Date(2026, 11, 1);

(function () {

  function initialize(jQuery) {
  const $ = jQuery;
  let dp = null;
  let originalFilter = null;
  let appliedFilter = null;
  let originalStartDate = null;
  let cartRefreshTimer = null;
  let cartRequestVersion = 0;
  let validatingDate = false;
  let appliedRulesKey = null;

  function log(...args) {
    if (ENABLE_LOGS) {
      console.log("[Delivery Date]", ...args);
    }
  }

  function getMessage(key, values = {}) {
    return MESSAGES[ACTIVE_LANGUAGE][key].replace(/\{(\w+)\}/g, (match, name) =>
      values[name] ?? match
    );
  }

  function formatDisplayDate(date) {
    return new Intl.DateTimeFormat(DATE_LOCALE, {
      day: "numeric",
      month: "long",
      year: "numeric"
    }).format(date);
  }

  function parseInputDate(value) {
    if (!dp || typeof value !== "string" || !value.trim()) return null;
    const parsed = dp.parseDate(value);
    if (Number.isNaN(parsed.getTime()) || dp.formatDate(parsed) !== value) return null;
    return parsed;
  }

  function formatInputDate(value) {
    const date = parseInputDate(value);
    return date ? formatDisplayDate(date) : value;
  }

  function showDeliveryDateUpdatedModal(oldDate, newDate) {
    $("#delivery-date-modal").remove();
    $("body").append(`
        <div id="delivery-date-modal" class="delivery-date-modal-overlay">
            <div class="delivery-date-modal">
                <div class="delivery-date-icon">📅</div>

                <h3>${getMessage("deliveryDateUpdated")}</h3>

                <p>
                    ${getMessage("unavailableDate", { date: $("<div>").text(formatInputDate(oldDate)).html() })}
                </p>

                <p>
                    ${getMessage("nextAvailableDate")}
                </p>

                <div class="delivery-date-selected">
                    ${formatInputDate(newDate)}
                </div>

                <button type="button" id="delivery-date-modal-ok">
                    ${getMessage("ok")}
                </button>
            </div>
        </div>
    `);

    $("#delivery-date-modal-ok").on("click", function () {
        $("#delivery-date-modal").fadeOut(200, function () {
            $(this).remove();
        });
    });
  }

  function getMixedCartRemovalPlan(cartItems) {
    const items = Array.isArray(cartItems) ? cartItems : [];
    const restrictedIndex = items.findIndex(item =>
      DECEMBER_PRODUCT_ID_SET.has(String(item.product_id))
    );
    const otherIndex = items.findIndex(item =>
      !DECEMBER_PRODUCT_ID_SET.has(String(item.product_id))
    );
    // Cart items are newest-first, so a lower index means the product was added later.
    const removeRestricted = restrictedIndex < otherIndex;

    return {
      removeRestricted,
      description: removeRestricted
        ? getMessage("preorderAddedLast")
        : getMessage("preorderAddedFirst"),
      buttonLabel: removeRestricted
        ? getMessage("removePreorder")
        : getMessage("keepPreorder")
    };
  }

  function showMixedCartModal(plan) {
    $("#mixed-product-modal").remove();
    $("body").append(`
        <div id="mixed-product-modal" role="presentation">
        <style>
            #mixed-product-modal {
                position: fixed;
                inset: 0;
                z-index: 2147483000;
                display: grid;
                place-items: center;
                padding: 20px;
                overflow-y: auto;
                overscroll-behavior: contain;
                background: rgba(20, 16, 13, 0.56);
                backdrop-filter: blur(3px);
            }
            #mixed-product-modal .mixed-product-dialog {
                box-sizing: border-box;
                width: min(100%, 440px);
                max-height: calc(100vh - 40px);
                max-height: calc(100dvh - 40px);
                overflow-y: auto;
                overscroll-behavior: contain;
                padding: 32px;
                border: 1px solid rgba(64, 33, 15, 0.08);
                border-radius: 16px;
                background: #fff;
                box-shadow: 0 24px 72px rgba(24, 17, 12, 0.24);
                color: #211b17;
                text-align: center;
                font-family: inherit;
            }
            #mixed-product-modal .mixed-product-icon {
                display: grid;
                width: 52px;
                height: 52px;
                margin: 0 auto 18px;
                place-items: center;
                border-radius: 50%;
                background: #f6eee8;
                font-size: 25px;
            }
            #mixed-product-modal h3 {
                margin: 0 0 12px;
                color: inherit;
                font-size: 22px;
                font-weight: 600;
                line-height: 1.3;
                letter-spacing: -0.02em;
            }
            #mixed-product-modal .mixed-product-message {
                margin: 0 auto 12px;
                max-width: 350px;
                color: #655e59;
                font-size: 15px;
                line-height: 1.6;
            }
            #mixed-product-modal #mixed-product-order-message {
                margin-bottom: 24px;
            }
            #mixed-product-modal .mixed-product-date {
                white-space: nowrap;
                color: #40210f;
                font-weight: 700;
                text-decoration: underline;
                text-decoration-color: #d9b79f;
                text-decoration-thickness: 2px;
                text-underline-offset: 3px;
            }
            #mixed-product-modal .mixed-product-actions {
                display: grid;
                gap: 10px;
            }
            #mixed-product-modal button {
                box-sizing: border-box;
                width: 100%;
                min-height: 48px;
                margin: 0;
                padding: 12px 16px;
                border: 1px solid transparent;
                border-radius: 999px;
                font: inherit;
                font-size: 14px;
                font-weight: 600;
                line-height: 1.35;
                white-space: normal;
                overflow-wrap: anywhere;
                touch-action: manipulation;
                cursor: pointer;
                transition: background-color 150ms ease, border-color 150ms ease, color 150ms ease;
            }
            #mixed-product-modal #mixed-product-modal-remove {
                background: #40210f;
                color: #fff;
            }
            #mixed-product-modal #mixed-product-modal-remove:hover:not(:disabled) {
                background: #5a321d;
            }
            #mixed-product-modal #mixed-product-modal-ok {
                border-color: #ded8d3;
                background: #fff;
                color: #302720;
            }
            #mixed-product-modal #mixed-product-modal-ok:hover {
                border-color: #a99a8e;
                background: #faf8f6;
            }
            #mixed-product-modal button:focus-visible {
                outline: none !important;
                outline-offset: 0 !important;
            }
            #mixed-product-modal button:disabled {
                cursor: wait;
                opacity: 0.7;
            }
            #mixed-product-modal-error:not([hidden]) {
                margin: -8px 0 16px;
                color: #a12622;
                font-size: 14px;
                line-height: 1.5;
                text-align: left;
            }
            @media (max-width: 480px) {
                #mixed-product-modal {
                    padding:
                        max(16px, env(safe-area-inset-top))
                        max(16px, env(safe-area-inset-right))
                        max(16px, env(safe-area-inset-bottom))
                        max(16px, env(safe-area-inset-left));
                }
                #mixed-product-modal .mixed-product-dialog {
                    width: 100%;
                    max-height: calc(100vh - 32px);
                    max-height: calc(100dvh - 32px);
                    padding: 24px 20px 20px;
                    border-radius: 14px;
                }
                #mixed-product-modal .mixed-product-icon {
                    width: 44px;
                    height: 44px;
                    margin-bottom: 14px;
                    font-size: 22px;
                }
                #mixed-product-modal h3 {
                    margin-bottom: 10px;
                    font-size: 19px;
                }
                #mixed-product-modal .mixed-product-message {
                    font-size: 14px;
                }
                #mixed-product-modal #mixed-product-order-message {
                    margin-bottom: 20px;
                }
                #mixed-product-modal button {
                    min-height: 48px;
                    padding: 12px 14px;
                    font-size: 13px;
                }
            }
            @media (prefers-reduced-motion: reduce) {
                #mixed-product-modal button {
                    transition: none;
                }
            }
        </style>
            <div class="mixed-product-dialog" role="dialog" aria-modal="true" aria-labelledby="mixed-product-modal-title" aria-describedby="mixed-product-modal-description mixed-product-order-message">
                <div class="mixed-product-icon" aria-hidden="true">⚠️</div>

                <h3 id="mixed-product-modal-title">${getMessage("mixedCartTitle")}</h3>

                <p class="mixed-product-message" id="mixed-product-modal-description">
                    ${getMessage("preorderAvailableFrom", {
                      date: formatDisplayDate(DECEMBER_MINIMUM_DATE)
                    })}
                </p>
                <p class="mixed-product-message" id="mixed-product-order-message"></p>

                <p class="mixed-product-error" id="mixed-product-modal-error" role="alert" hidden></p>

                <div class="mixed-product-actions">
                    <button type="button" id="mixed-product-modal-remove"></button>

                    <button type="button" id="mixed-product-modal-ok">
                        ${getMessage("continue")}
                    </button>
                </div>
            </div>
        </div>
    `);

    $("#mixed-product-order-message").text(plan.description);
    $("#mixed-product-modal-remove").text(plan.buttonLabel);

    const $modal = $("#mixed-product-modal");
    const closeModal = function () {
      $modal.fadeOut(200, function () {
        $(this).remove();
      });
      $(document).off("keydown.mixedProductModal");
    };

    $("#mixed-product-modal-remove").on("click", async function () {
      const $button = $(this);
      const $error = $("#mixed-product-modal-error");
      $button.prop("disabled", true).text(getMessage("removing"));
      $error.prop("hidden", true).text("");
      let updatedCart;

      try {
        const cartUrl = `${window.Shopify?.routes?.root || "/"}cart.js`;
        const cartResponse = await fetch(cartUrl, {
          headers: { Accept: "application/json" }
        });
        if (!cartResponse.ok) {
          throw new Error(`Cart request failed with status ${cartResponse.status}`);
        }

        const cart = await cartResponse.json();
        if (!Array.isArray(cart.items)) {
          throw new Error("Cart response did not contain an items array");
        }
        window.cartItems = cart.items;
        window.cartProductIds = cart.items.map(item => item.product_id);

        const restrictedItems = cart.items.filter(item =>
          DECEMBER_PRODUCT_ID_SET.has(String(item.product_id))
        );
        const otherItems = cart.items.filter(item =>
          !DECEMBER_PRODUCT_ID_SET.has(String(item.product_id))
        );
        if (restrictedItems.length === 0 || otherItems.length === 0) {
          updatedCart = cart;
        } else {
          const removalPlan = getMixedCartRemovalPlan(cart.items);
          const itemsToRemove = removalPlan.removeRestricted
            ? restrictedItems
            : otherItems;
          const updates = {};
          itemsToRemove.forEach(item => {
            if (!item.key) {
              throw new Error("A cart item to remove is missing its line item key");
            }
            updates[item.key] = 0;
          });

          const updateResponse = await fetch(
            `${window.Shopify?.routes?.root || "/"}cart/update.js`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: JSON.stringify({ updates })
            }
          );
          if (!updateResponse.ok) {
            throw new Error(`Cart update failed with status ${updateResponse.status}`);
          }

          updatedCart = await updateResponse.json();
          if (!Array.isArray(updatedCart.items)) {
            throw new Error("Cart update response did not contain an items array");
          }
          const removedItemsRemain = updatedCart.items.some(item =>
            removalPlan.removeRestricted
              ? DECEMBER_PRODUCT_ID_SET.has(String(item.product_id))
              : !DECEMBER_PRODUCT_ID_SET.has(String(item.product_id))
          );
          if (removedItemsRemain) {
            throw new Error("Shopify did not remove all items requested");
          }
        }
      } catch (error) {
        console.error("[Delivery Date] Unable to update cart products.", error);
        $error
          .text(getMessage("cartUpdateFailed"))
          .prop("hidden", false);
        $button.prop("disabled", false).text(plan.buttonLabel);
        return;
      }

      window.cartItems = updatedCart.items;
      window.cartProductIds = updatedCart.items.map(item => item.product_id);
      closeModal();

      try {
        applyCartDateRules();
      } catch (error) {
        console.error(
          "[Delivery Date] Products were removed, but the date picker could not be refreshed.",
          error
        );
      }

      document.dispatchEvent(new CustomEvent("cart:updated", {
        detail: updatedCart
      }));

      const cartPath = `${window.Shopify?.routes?.root || "/"}cart`;
      const currentPath = window.location.pathname.replace(/\/+$/, "") || "/";
      const normalizedCartPath = cartPath.replace(/\/+$/, "") || "/cart";

      if (currentPath === normalizedCartPath) {
        window.location.reload();
      } else {
        window.location.assign(cartPath);
      }
    });

    $("#mixed-product-modal-ok").on("click", closeModal).trigger("focus");
    $(document).on("keydown.mixedProductModal", function (event) {
      if (event.key === "Escape") {
        closeModal();
      }
    });
  }

  function checkForMixedCart() {
    const cartProductIds = (window.cartProductIds || []).map(String);
    const hasDecemberProduct = cartProductIds.some(id =>
      DECEMBER_PRODUCT_ID_SET.has(id)
    );
    const hasOtherProduct = cartProductIds.some(id =>
      !DECEMBER_PRODUCT_ID_SET.has(id)
    );

    if (hasDecemberProduct && hasOtherProduct) {
      const plan = getMixedCartRemovalPlan(window.cartItems);
      if (!$("#mixed-product-modal").length) {
        showMixedCartModal(plan);
      } else {
        $("#mixed-product-order-message").text(plan.description);
        $("#mixed-product-modal-remove").text(plan.buttonLabel);
      }
    } else {
      $(document).off("keydown.mixedProductModal");
      $("#mixed-product-modal").remove();
    }
  }

  /**
   * Override Tuesday & Thursday for testing
   */

  function enableTestDays() {
      if (!ENABLE_TEST_DAYS) return;

      if (typeof originalFilter !== "function") return;

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      dp.options.filter = function(date, view) {
          // Keep original behavior for non-day views
          if (view !== "day") {
              return originalFilter.call(this, date, view);
          }
          const result = originalFilter.call(this, date, view);

          const checkDate = new Date(date);
          checkDate.setHours(0, 0, 0, 0);
          // Never enable today or any past date
          if (checkDate <= today) {
              return result;
          }
          const day = checkDate.getDay();

          // Only enable future Tuesdays & Thursdays
          if ((day === 2 || day === 4) && result === false) {
              return true;
          }
          return result;
      };
      refreshPicker();
  }

  function disableNextDayAfterCutoff() {
    // Only apply after cutoff
    if (Number(window.storeTime) < CUT_OFF_HOUR) {
        return;
    }

    if (typeof originalFilter !== "function") {
        return;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Disable tomorrow
    const nextDate = new Date(today);
    nextDate.setDate(nextDate.getDate() + 1);

    dp.options.filter = function (date, view) {
        // Keep original behaviour
        if (view !== "day") {
            return originalFilter.call(this, date, view);
        }
        const result = originalFilter.call(this, date, view);
        const checkDate = new Date(date);
        checkDate.setHours(0, 0, 0, 0);
        // Disable tomorrow
        if (checkDate.getTime() === nextDate.getTime()) {
            return false;
        }
        return result;
    };
    refreshPicker();
  }

  function applyCartDateRules() {
    const cartProductIds = (window.cartProductIds || []).map(String);
    const hasDecemberProduct = cartProductIds.some(id =>
      DECEMBER_PRODUCT_ID_SET.has(id)
    );

    const rulesKey = `${hasDecemberProduct}:${window.storeTime}:${new Date().toDateString()}`;
    if (dp.options.filter === appliedFilter && appliedRulesKey === rulesKey) return;
    appliedRulesKey = rulesKey;
    log("December-restricted product in cart:", hasDecemberProduct);
    const tomorrow = new Date();
    tomorrow.setHours(0, 0, 0, 0);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const minimumDate = new Date(DECEMBER_MINIMUM_DATE);
    minimumDate.setHours(0, 0, 0, 0);

    const baseFilter = originalFilter;
    const cartDateFilter = function (date, view) {
      const allowed = typeof baseFilter === "function"
        ? baseFilter.call(this, date, view)
        : true;

      if (view !== "day" || allowed === false) {
        return allowed;
      }

      const checkDate = new Date(date);
      checkDate.setHours(0, 0, 0, 0);

      if (hasDecemberProduct && checkDate < minimumDate) {
        return false;
      }

      if (
        Number(window.storeTime) >= CUT_OFF_HOUR &&
        checkDate.getTime() === tomorrow.getTime()
      ) {
        return false;
      }

      return true;
    };
    cartDateFilter.deliveryDateBaseFilter = baseFilter;
    dp.options.filter = cartDateFilter;
    appliedFilter = dp.options.filter;

    let startDate = new Date(originalStartDate);
    startDate.setHours(0, 0, 0, 0);
    if (Number(window.storeTime) >= CUT_OFF_HOUR) {
      startDate.setDate(startDate.getDate() + 1);
    }
    if (hasDecemberProduct && startDate < minimumDate) {
      startDate = new Date(minimumDate);
    }

    for (let i = 0; i < 370 && dp.options.filter(startDate, "day") === false; i++) {
      startDate.setDate(startDate.getDate() + 1);
    }

    dp.options.startDate = startDate;
    if (typeof dp.setStartDate === "function") {
      dp.setStartDate(startDate);
    } else {
      refreshPicker();
    }
    validateSelectedDate();

    checkForMixedCart();
  }

  function refreshCartProducts() {
    const cartUrl = `${window.Shopify?.routes?.root || "/"}cart.js`;
    const requestVersion = ++cartRequestVersion;

    fetch(cartUrl, {
      headers: { Accept: "application/json" }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`Cart request failed with status ${response.status}`);
        }
        return response.json();
      })
      .then(cart => {
        if (!Array.isArray(cart.items)) {
          throw new Error("Cart response did not contain an items array");
        }
        if (requestVersion !== cartRequestVersion) return;
        window.cartItems = cart.items;
        window.cartProductIds = cart.items.map(item => item.product_id);
        checkForMixedCart();
        if (dp) {
          applyCartDateRules();
        }
      })
      .catch(error => {
        console.error("[Delivery Date] Unable to refresh cart products.", error);
      });
  }

  function scheduleCartRefresh() {
    window.clearTimeout(cartRefreshTimer);
    cartRefreshTimer = window.setTimeout(refreshCartProducts, 500);
  }

  function refreshPicker() {

    if (dp.built && typeof dp.render === "function") {
      dp.render();
    }
  }

  function validateSelectedDate() {

    if (!dp || validatingDate) return;

    const value = $("#sbt_datepicker").val();
    if (!value) return;
    const selected = parseInputDate(value);
    const minimumDate = new Date(dp.options.startDate);
    minimumDate.setHours(0, 0, 0, 0);
    if (Number.isNaN(minimumDate.getTime())) return;

    if (
      selected && selected >= minimumDate &&
      dp.options.filter(selected, "day") !== false
    ) {
      return;
    }

    const nextDate = new Date(minimumDate);
    for (let i = 0; i < 370; i++) {
        if (dp.options.filter(nextDate, "day") !== false) {

            const formatted = dp.formatDate(nextDate);
            validatingDate = true;
            try {
              dp.setDate(nextDate);
              showDeliveryDateUpdatedModal(value, formatted);
            } finally {
              validatingDate = false;
            }
            return;
        }
        nextDate.setDate(nextDate.getDate() + 1);
    }
  }

  function protectDateInput() {
    const input = document.getElementById("sbt_datepicker");
    if (!input) return;
    // Ensure readonly initially
    input.setAttribute("readonly", "readonly");

    const observer = new MutationObserver(function (mutations) {

        for (const mutation of mutations) {

            if (
                mutation.type === "attributes" &&
                mutation.attributeName === "readonly"
            ) {
                if (!input.hasAttribute("readonly")) {
                  input.setAttribute("readonly", "readonly");
                }
            }
        }
    });

    observer.observe(input, {
        attributes: true,
        attributeFilter: ["readonly"]
    });
  }

  const setupDatepicker = () => {

    const $field = $("#sbt_datepicker");

    if (!$field.length) return;

    const instance = $field.data("datepicker");

    if (!instance) return;

    if (instance !== dp) {
      dp = instance;
      const initialFilter = dp.options.filter;
      originalFilter = initialFilter?.deliveryDateBaseFilter || initialFilter;
      appliedFilter = null;
      originalStartDate = dp.options.startDate;

      protectDateInput();
      log("Datepicker Ready");
    } else if (dp.options.filter !== appliedFilter) {
      const replacementFilter = dp.options.filter;
      const baseFilter = replacementFilter?.deliveryDateBaseFilter;
      if (baseFilter) {
        originalFilter = baseFilter;
        appliedFilter = replacementFilter;
        return;
      }
      originalFilter = replacementFilter;
    } else {
      return;
    }

    applyCartDateRules();

  };

  const observer = new MutationObserver(function (mutations) {
    const containsDatepicker = node => node.nodeType === 1 && (
      node.id === "sbt_datepicker" || node.querySelector?.("#sbt_datepicker")
    );
    if (mutations.some(mutation =>
      [...mutation.addedNodes, ...mutation.removedNodes].some(containsDatepicker)
    )) {
      setupDatepicker();
    }
  });

  const originalVal = $.fn.val;

  let dateValidationTimer = null;
  $.fn.val = function () {
    const input = arguments.length
      ? document.getElementById("sbt_datepicker")
      : null;
    const writesDate = input && Array.prototype.indexOf.call(this, input) !== -1;
    const previousValue = writesDate ? input.value : null;
    const result = originalVal.apply(this, arguments);

    if (writesDate && !validatingDate && input.value !== previousValue) {
      window.clearTimeout(dateValidationTimer);
      dateValidationTimer = window.setTimeout(validateSelectedDate, 0);
    }

    return result;
  };

  $(document).on("input change", "#sbt_datepicker", validateSelectedDate);

  let lastDateField = null;
  let lastDateValue;
  // Property assignments and autofill may change value without firing an event.
  window.setInterval(function () {
    const input = document.getElementById("sbt_datepicker");
    if (!input) {
      lastDateField = null;
      return;
    }
    setupDatepicker();
    if (input !== lastDateField || input.value !== lastDateValue) {
      lastDateField = input;
      validateSelectedDate();
      lastDateValue = input.value;
    }
  }, 100);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  setupDatepicker();
  checkForMixedCart();

  document.addEventListener("change", function (event) {
    const target = event.target;
    if (
      target instanceof Element &&
      (
        target.matches('input[name^="updates["], input[name="quantity"], select[name="quantity"]')
      )
    ) {
      scheduleCartRefresh();
    }
  });

  document.addEventListener("click", function (event) {
    const target = event.target;
    if (
      target instanceof Element &&
      target.closest('a[href*="/cart/change"], button[name="remove"], [data-cart-remove], cart-remove-button')
    ) {
      scheduleCartRefresh();
    }
  });

  document.addEventListener("submit", function (event) {
    const form = event.target;
    if (
      form instanceof HTMLFormElement &&
      /\/cart\/(add|change|update|clear)/.test(form.action)
    ) {
      scheduleCartRefresh();
    }
  });

  ["cart:updated", "cart:change", "cart:refresh", "cart:rendered"].forEach(eventName => {
    document.addEventListener(eventName, scheduleCartRefresh);
    window.addEventListener(eventName, scheduleCartRefresh);
  });

  }

  let attempts = 0;
  const jqueryWait = window.setInterval(function () {
    if (window.jQuery && window.jQuery.fn) {
      window.clearInterval(jqueryWait);
      const cartUrl = `${window.Shopify?.routes?.root || "/"}cart.js`;

      fetch(cartUrl, {
        headers: { Accept: "application/json" }
      })
        .then(response => {
          if (!response.ok) {
            throw new Error(`Cart request failed with status ${response.status}`);
          }
          return response.json();
        })
        .then(cart => {
          if (!Array.isArray(cart.items)) {
            throw new Error("Cart response did not contain an items array");
          }
          window.cartItems = cart.items;
          window.cartProductIds = cart.items.map(item => item.product_id);
          initialize(window.jQuery);
        })
        .catch(error => {
          console.error(
            "[Delivery Date] Unable to load cart products; using Liquid cart data.",
            error
          );
          initialize(window.jQuery);
        });
      return;
    }

    attempts++;
    if (attempts >= 200) {
      window.clearInterval(jqueryWait);
      console.error("[Delivery Date] jQuery did not load; date picker setup was skipped.");
    }
  }, 50);

})();